module.exports = __webpack_public_path__ + "static/media/Download.25093413.svg";